/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_NeckInputs */

const en_us2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neck`)
};

const pt_br2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const es_419_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuello`)
};

const pt_pt2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescoço`)
};

const fr_fr2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cou`)
};

const de_de2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hals`)
};

const it_it2_body_measures_site_neck = /** @type {(inputs: Body_Measures_Site_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collo`)
};

/**
* | output |
* | --- |
* | "Neck" |
*
* @param {Body_Measures_Site_NeckInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_neck = /** @type {((inputs?: Body_Measures_Site_NeckInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_NeckInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_neck(inputs)
	if (locale === "es-419") return es_419_body_measures_site_neck(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_neck(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_neck(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_neck(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_neck(inputs)
	return en_us2_body_measures_site_neck(inputs)
});
export { body_measures_site_neck as "body-measures.site_neck" }